export default "__VITE_ASSET__DdWSF2dL__"